import { FC } from "react";

import ChevronRight from "~/icons/ChevronRight";
import { CateringEntry } from "~/modules/catering/hooks/useCateringEntry";

import styles from "./CateringNavItem.module.css";

// The nav's catering row (C1a, mobile drawer) or item (C1c, desktop menu)
const CateringNavItem: FC<{
  entry: CateringEntry | null;
  variant: "drawer" | "menu";
  color?: string;
}> = ({ entry, variant, color }) => {
  if (!entry) {
    return null;
  }
  return (
    <button
      type="button"
      className={variant === "drawer" ? styles.drawerRow : styles.menuItem}
      style={{ color }}
      onClick={entry.go}
    >
      <span className={styles.text}>
        <span className={styles.title}>{entry.title}</span>
        <span className={styles.detail}>{entry.detail}</span>
      </span>
      {variant === "drawer" && <ChevronRight color="currentColor" />}
    </button>
  );
};

export default CateringNavItem;
